/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Forms_IntroInputs */

const en_pc_tut_forms_intro = /** @type {(inputs: Pc_Tut_Forms_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forms, comments, layers and attachments are all supported.`)
};

const zh_pc_tut_forms_intro = /** @type {(inputs: Pc_Tut_Forms_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持表单、批注、图层和附件。`)
};

/**
* | output |
* | --- |
* | "Forms, comments, layers and attachments are all supported." |
*
* @param {Pc_Tut_Forms_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_forms_intro = /** @type {((inputs?: Pc_Tut_Forms_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Forms_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_forms_intro(inputs)
	return zh_pc_tut_forms_intro(inputs)
});
export { pc_tut_forms_intro as "pc.tut.forms.intro" }